import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Button, Input, TableCell, TableRow, TextField } from "@mui/material";
import * as React from "react";
import { IAPItem } from "./index";

interface IAPEntryProps {
    entry: IAPItem;
    classes: any;

    onRemove(item: IAPItem);

    onUpdate(item: IAPItem);
}

export class IAPEntry extends React.Component<IAPEntryProps, IAPItem> {

    constructor(props: IAPEntryProps) {
        super(props);

        this.state = {
            id: this.props.entry.id,
            productId: this.props.entry.productId,
            price: this.props.entry.price,
            type: this.props.entry.type,
            platform: this.props.entry.platform,
        };
    }

    onValueChange = (key: keyof IAPItem, value: any) => {
        this.setState(state => {
            // @ts-ignore
            state[key] = value;

            return state;
        }, () => {
            this.props.onUpdate(this.state);
        });
    };

    remove = () => {
        if (!confirm("Are you sure you want to delete this IAP?")) {
            return;
        }

        this.props.onRemove(this.state);
    };

    render() {
        return <TableRow key={this.state.id} hover={true}>
            <TableCell>
                <TextField size="small" variant="outlined" value={this.state.productId}
                       onChange={(e) => this.onValueChange("productId", e.target.value)}
                       style={{width: "100%"}}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" type="number" value={this.state.price}
                       onChange={(e) => this.onValueChange("price", e.target.value)}/>
            </TableCell>
            <TableCell>
                <Button disableElevation onClick={this.remove} size="small">
                    <DeleteForeverIcon color={"error"}/>
                </Button>
            </TableCell>
        </TableRow>;
    }
}
